export {default as Head } from './head.component';